import { useMutation } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchMeliFreeShipping from '../Services/fetchMeliFreeShipping';

export default function useMeliFreeShipping() {
	const { accessToken } = useAuth();

	const meliFreeShippingMutation = useMutation({
		mutationFn: (params) => fetchMeliFreeShipping(params, accessToken),
	});

	return meliFreeShippingMutation;
}
